"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getPurchaseOriginsMetaData = require("./getPurchaseOriginsMetaData");
Object.keys(_getPurchaseOriginsMetaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPurchaseOriginsMetaData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPurchaseOriginsMetaData[key];
    }
  });
});
var _getTranslationsProps = require("./getTranslationsProps");
Object.keys(_getTranslationsProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTranslationsProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTranslationsProps[key];
    }
  });
});
var _useMiddleware = require("./useMiddleware");
Object.keys(_useMiddleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useMiddleware[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useMiddleware[key];
    }
  });
});
var _wrapActionWithDispatch = require("./wrap-action-with-dispatch");
Object.keys(_wrapActionWithDispatch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _wrapActionWithDispatch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _wrapActionWithDispatch[key];
    }
  });
});
